<template>
    <div class="container">
        <span @click="$emit('close')" role="button"><small><i class="fa-solid fa-chevron-left me-2"></i>{{ $t('common.back') }}</small></span>
        <h2 class="my-3">{{ isEditMode ? $t('modal.editReminder') : $t('modal.addReminder') }}</h2>
        <div class="mb-3">
            <label for="descriptionInput" class="form-label"><small>{{ $t('modal.content') }}</small></label>
            <textarea id="descriptionInput" class="form-control bg-body-tertiary" v-model="reminder" required
                :placeholder="$t('modal.reminderPlaceholder')"></textarea>
        </div>

        <div class="row mt-3">
            <div class="col">
                <button @click="$emit('close')" class="btn btn-outline-primary w-100" :disabled="actionInProgress">{{ $t('common.cancel') }}</button>
            </div>
            <div class="col">
                <button @click="submitReminder" class="btn btn-primary w-100" :disabled="actionInProgress || !reminder.trim()">
                    {{ isEditMode ? $t('common.save') : $t('modal.add') }}
                </button>
            </div>
        </div>

    </div>
</template>


<script>
import axios from '@/services/axios';

export default {
    props: {
        projectId: {
            type: Number,
            required: true
        },
        reminderToEdit: {
            type: Object,
            default: null
        }
    },
    emits: ['close', 'reminder-added', 'reminder-updated'],
    data() {
        return {
            reminder: '',
            // Held only while the request is in flight, so a slow network
            // cannot turn one click into two records.
            actionInProgress: false,
        };
    },
    computed: {
        isEditMode() {
            return !!(this.reminderToEdit && this.reminderToEdit.id);
        },
    },
    mounted() {
        if (this.isEditMode) {
            this.reminder = this.reminderToEdit.reminder ?? '';
        }
    },
    methods: {
        async submitReminder() {
            // The API answers a blank reminder with a 400; the button is
            // disabled for it too, this only guards a programmatic call.
            const text = this.reminder.trim();
            if (this.actionInProgress || !text) return;
            this.actionInProgress = true;
            try {
                if (this.isEditMode) {
                    const response = await axios.put(`/projects/${this.projectId}/reminders/${this.reminderToEdit.id}`, { reminder: text });
                    this.$emit('reminder-updated', response.data.data);
                } else {
                    const response = await axios.post(`/projects/${this.projectId}/reminders`, { reminder: text });
                    this.$emit('reminder-added', response.data.data);
                }
                this.reminder = '';
                this.$emit('close');
            } catch (error) {
                console.error('Error saving reminder:', error);
                // Covers 403 "Project is closed" and 404 "Reminder not found".
                this.$root.$refs.globalAlert?.showAlert(
                    error.response?.data?.error?.message || this.$t('common.failed'),
                    'danger'
                );
            } finally {
                this.actionInProgress = false;
            }
        }
    }
};
</script>


<style scoped></style>
